
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MetaHead from "./MetaHead";
import { motion } from "framer-motion";

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  image?: string;
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  title = "BubbleCare | Connected Care Networks for Your Loved Ones",
  description = "Connect Your Loved One's Care Network with BubbleCare",
  image = "/lovable-uploads/c43492c6-9bd3-4c28-aac2-d61ab718c15d.png"
}) => {
  const { pathname } = useLocation();
  
  // Scroll to top when pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden font-['SF_Pro_Display',_-apple-system,_BlinkMacSystemFont,_sans-serif]">
      <MetaHead 
        title={title}
        description={description}
        image={image}
        url={`https://bubblecare.app${pathname}`}
      />
      <Header />
      <motion.main 
        className="flex-grow w-full"
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -15 }}
        transition={{ 
          duration: 0.4, 
          ease: [0.45, 0, 0.2, 1] 
        }}
      >
        {children}
      </motion.main>
      <Footer />
    </div>
  );
};

export default Layout;
